<template>
  <section class="section-container">
    <h1 class="header-2 colour-text-darker heading-spacing" style="text-align: left; font-size: 34px;">Information</h1>
    <div class="container-padding my-6 pb-5">
      <div class="columns is-mobile mb-4">
        <div class="column pl-0 has-text-left is-1 is-offset-1-mobile is-offset-1-tablet">
          <p class="colour-text">Name</p>
        </div>
        <div class="column px-0 is-2 is-offset-6-mobile is-offset-7-tablet">
          <p class="colour-text">Update Date</p>
        </div>
      </div>

      <!-- pdfs name and file published date-->
      <div class="columns is-mobile px-0 py-1 card-shadow" v-for="article in articles.data" :key="article.id" style="border-radius: 0.6rem;">
        <figure class="column icon-column px-0 pt-3 pb-0 is-1-mobile is-1-tablet">
          <b-icon
            class="pdf-icon"
            :icon="checkIconType(article.attributes.link)"
            size="is-small">
          </b-icon>
        </figure>
        <p class="column px-0 py-2 is-7-mobile is-8-tablet has-text-left">
          <a :href="article.attributes.link" class="body-3 colour-secondary-01" style="font-weight: 500;" target="_blank">
            {{ article.attributes.name }}
          </a>
        </p>
        <p class="column px-0 py-2 is-2 colour-text" style="color: black;">{{ formatDate(article.attributes.publishedAt) }}</p>
        <a class="column py-2 is-2-mobile is-1-tablet colour-text" :href="article.attributes.link" target="_blank">
          <b-icon
            icon="download"
            size="is-small">
          </b-icon>
        </a>
      </div>
    </div>
  </section>
</template>

<script>
  import dayjs from 'dayjs';
  
  export default {
    data(){
      return{
        loadMore: false,
        articles:[]
      };
    },
    mounted(){
      let year = dayjs().year() - 3;
      this.$httpClientCMS({
        method: 'GET',
        url: 'api/informations?sort=publishedAt:desc&filters[publishedAt][$gte]=' + year + '-01-01'    
      })
      .then(resp =>{
        this.$set(this,'articles', resp.data)
      })
    },
    methods: {
      formatDate(apiDate){
        return dayjs(apiDate).format('DD MMM YYYY');
      },
      checkIconType(link){
        if(link.includes("pdf")){
          return "file-pdf-box";
        }
        return "video-box";
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../styles/font.scss';

  .section-container{
    font-size: 1rem;
    margin-top: 3em;
  }

  .heading-spacing{
    padding-left: 110px !important;
  }

  .container-padding{
    padding-left: 190px !important;
    padding-right: 190px !important;
  }

  .card-shadow {
    margin-bottom: 40px;
    box-shadow: 0 0 6px #CCCCCC;
  }

  .pdf-icon{
    color: red; 
    font-size: 1.4rem;
  }

  @media screen and (max-width:1290px) and (min-width: 1024px){
    .heading-spacing{
      padding-left: 55px !important;
    }

    .container-padding{
      padding-left: 140px !important;
      padding-right: 140px !important;
    }
  }

  @media screen and (max-width:1023px) {
    .heading-spacing{
      padding-left: 25px !important;
    }

    .container-padding{
      padding-left: 40px !important;
      padding-right: 50px !important;
    }
  }

  @media (max-width: 768px){
    .section-container{
      font-size: 0.9rem;
    }

    .pdf-icon {
      height: 15px !important;
    }
  }

  @media (max-width: 565px){
    .section-container{
      font-size: 0.7rem;
    }

    .pdf-icon {
      height: 10px !important;
    }
  }

</style>
